module.exports = __webpack_public_path__ + "img/produkt-brambory-varene.ae587928.jpg";